import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { AddCircleBlue, CustomDelete, FullTable } from 'components';
import { FindSuccess, Images, sortListByKey, useModal } from 'utils';
import { assessmentActions, httpRequestsOnSuccessActions } from 'store';
import { ACTION_TYPE, goalNotYet, assessmentHead, assessmentBody } from './constants';
import { AssessmentDetails } from './assessmentDetails';
import { AddAssessment } from './addAssessment';
import { useLocation } from 'react-router-dom';

const DELETE_ACTION_TYPE = 'DELETE_ASSESSMENT';

export const Assessment = ({ actionsSlot }) => {
    const client = useSelector((state) => state.client.clientItemInfo);
    const assessmentList = useSelector((state) => state.assessment.assessmentList);
    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const deleteSuccess = FindSuccess(DELETE_ACTION_TYPE);
    const { open } = useModal();

    const renderParams = () => {
        const pushInfo = {
            ...info,
            clientId: params?.id,
        };
        delete pushInfo.page;
        delete pushInfo.activeTab;
        delete pushInfo.clinicalTab;
        return pushInfo;
    };

    useEffect(() => {
        getAssessments();
    }, [info]);

    const getAssessments = (load) => {
        dispatch(assessmentActions.getAssessments(params?.id, renderParams(), load));
    };

    useEffect(() => {
        if (deleteSuccess?.length) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(DELETE_ACTION_TYPE));
        }
    }, [deleteSuccess]);

    const handleClickButton = (item, name) => {
        // if (name === 'edit') {
        //     open(<AddAssessment info={item} requestParams={renderParams()} />);
        // }
        if (name === 'delete') {
            open(
                <CustomDelete
                    text="Are you sure you want to delete this Assessment?"
                    info="Delete Assessment"
                    handleDel={() => dispatch(assessmentActions.deleteAssessment(item?.id, client?.id))}
                    actionType={DELETE_ACTION_TYPE}
                    body={
                        <div className="deleting-client-info-box">
                            <img src={Images.client} alt="icon" />
                            <p>{item?.name}</p>
                        </div>
                    }
                />
            );
        }
    };

    return (
        <div>
            {/*{RolePermission([PermissionList.CLIENT_CONTACT_MANAGE?.code]) &&*/}
            {actionsSlot &&
                createPortal(
                    <AddCircleBlue text={'Add Assessment'} handleClick={() => open(<AddAssessment requestParams={renderParams()} />)} />,
                    actionsSlot,
                )}
            {/*}*/}
            <FullTable
                head={assessmentHead}
                body={assessmentBody(renderParams())}
                loadingType={ACTION_TYPE}
                list={sortListByKey(assessmentList?.assessments, 'name')}
                listCount={assessmentList?.count}
                handleClickButton={handleClickButton}
                handleClick={(assessmentId) => open(<AssessmentDetails assessmentId={assessmentId} requestParams={renderParams()} />)}
                notYet={goalNotYet}
                margin={'16px 0 0 0'}
            />
        </div>
    );
};
